module.exports = __webpack_public_path__ + "img/qr-code.1ea1c378.jpeg";